export default "_This paragraph was included from `_snippet.qmd` via the `{{< include >}}` shortcode._\n"